export function ComingSoon() {
  return (
    <div style={{ padding: 40, textAlign: 'center' }}>
      <h2>Coming Soon</h2>
      <p>This page is under development.</p>
    </div>
  );
}
